import {
    Avatar,
    Button,
    ListItem,
    ListItemAvatar,
    ListItemButton,
    ListItemText,
    Typography,
    useTheme,
} from '@mui/material';
import { Theme } from '@mui/material/styles';
import { useHistory } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import { contactRoutes } from '../../../routes';
import { QuickPhoneSearch } from '../../../sic-lib/types/QuickPhoneSearch';
import { startCall } from '../../../store/dialer';
import { useAppDispatch } from '../../../store/hooks';
import DisplayPhoneNumber from '../../Shared/DisplayPhoneNumber/DisplayPhoneNumber';

interface Props {
    searchResult: QuickPhoneSearch;
    handleClose: () => void;
}

export const QuickCallListItem = ({ searchResult, handleClose: handleClick }: Props) => {
    const { classes } = useStyles();
    const dispatch = useAppDispatch();
    const history = useHistory();
    const theme = useTheme();

    const handleMakeCall = () => {
        //navigate to contact details
        history.push(contactRoutes.setDetails(searchResult.contactId));

        //if they dont the consent, dont make the call
        if (!searchResult.hasConsent) return;

        dispatch(
            startCall({
                phoneNumber: searchResult.matchedValue,
                contactId: searchResult.contactId,
                firstName: searchResult.firstName || '',
                lastName: searchResult.lastName || '',
            }),
        );

        handleClick();
    };

    const handleClickItem = () => {
        //navigate to contact details
        history.push(contactRoutes.setDetails(searchResult.contactId));
    };

    return (
        <ListItem
            disablePadding
            secondaryAction={
                <Button
                    variant="contained"
                    color="success"
                    disabled={!searchResult.hasConsent}
                    size="small"
                    onClick={handleMakeCall}
                >
                    Call
                </Button>
            }
        >
            <ListItemButton
                dense
                divider
                sx={{ pt: 1, '&.MuiListItemButton-root': { pr: 11 } }}
                onClick={handleClickItem}
            >
                <ListItemAvatar>
                    <Avatar variant="rounded">
                        {searchResult.firstName && searchResult.firstName[0]}
                    </Avatar>
                </ListItemAvatar>
                <ListItemText
                    primary={
                        <>
                            {searchResult.firstName} {searchResult.lastName}{' '}
                            {!searchResult.hasConsent && (
                                <Typography variant="caption" color={theme.palette.error.main}>
                                    {' '}
                                    &bull; No Consent
                                </Typography>
                            )}
                        </>
                    }
                    secondary={
                        <>
                            <DisplayPhoneNumber phoneNumber={searchResult.matchedValue} /> &bull;{' '}
                            {searchResult.matchedField}
                        </>
                    }
                />
            </ListItemButton>
        </ListItem>
    );
};

//implied consent

const useStyles = makeStyles()((theme: Theme) => ({}));
